import { Show } from "solid-js"
import LoadingSpinner from "./LoadingSpinner"
import { useSwarm } from "../SwarmContext"
import SectionHeader from "./SectionHeader"

export function GlobalStats() {
	const {
		nodesConnected,
		nodesConnectedLoading,
		nodesConnectedError,

		uniqueVoters,
		uniqueVotersLoading,
		uniqueVotersError,
	} = useSwarm()

	return (
		<div class="grid grid-rows-1 gap-2 mb-10">
			<SectionHeader title={"All Nodes"} />
			<div class="grid grid-cols-1 md:grid-cols-2 gap-2">
				<div class="border border-2 border-dotted p-2 bg-base-200 border-base-content">
					Current Nodes Connected:
					<Show when={nodesConnectedLoading() || nodesConnectedError() || nodesConnected().count <= 50} fallback={nodesConnected().count}>
						<LoadingSpinner message="..." class="inline" />
					</Show>
				</div>
				<div class="border border-2 border-dotted p-2 bg-base-200 border-base-content">
					Total Models Trained:
					<Show when={uniqueVotersLoading() || uniqueVotersError()} fallback={uniqueVoters()?.count}>
						<LoadingSpinner message="..." class="inline" />
					</Show>
				</div>
			</div>
		</div>
	)
}
